import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import User from '../../../../../Model/User';
import useSessionStore from '../../../../../hooks/useSessionStore';
import WorkoutHistory from '../WorkoutHistory';
import ExerciseReplacements from './ExerciseReplacements';
import { Container, TabPanel } from './styles';
import texts from './texts.json';

const WorkoutHistoryTabs = ({ userDoc, coachId }) => {
  const { isCoachAssistant, isAdmin } = useSessionStore();
  const canSeeReplacements = isCoachAssistant || isAdmin;

  const [tab, setTab] = useState(0);
  const onChange = useCallback((_, value) => setTab(value), []);

  if (!canSeeReplacements) {
    return <WorkoutHistory user={userDoc.id} coachId={coachId} />;
  }

  return (
    <Container>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tab} onChange={onChange}>
          <Tab label={texts.tabHistory} />
          <Tab label={texts.tabReplacements} />
        </Tabs>
      </Box>
      <TabPanel value={tab} index={0}>
        <WorkoutHistory user={userDoc.id} coachId={coachId} />
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <ExerciseReplacements userDoc={userDoc} />
      </TabPanel>
    </Container>
  );
};

WorkoutHistoryTabs.propTypes = {
  userDoc: PropTypes.instanceOf(User).isRequired,
  coachId: PropTypes.string.isRequired,
};

export default WorkoutHistoryTabs;
